import { ColorMatchRuntimeInfo } from "@/lib/ai/color-match/utils"

const colorMatchRuntimeInfoMap = new Map<string, ColorMatchRuntimeInfo>()

export function getColorMatchRuntimeInfo(imageId: string) {
	return colorMatchRuntimeInfoMap.get(imageId)
}

export function setColorMatchRuntimeInfo(imageId: string, info: ColorMatchRuntimeInfo) {
	colorMatchRuntimeInfoMap.set(imageId, info)
}

export function clearColorMatchRuntimeInfo(imageId: string) {
	colorMatchRuntimeInfoMap.delete(imageId)
}

export function clearAllColorMatchRuntimeInfo() {
	colorMatchRuntimeInfoMap.clear()
}
